export default __webpack_public_path__ + "static/006-986026826a644dd0951b9fbfb43e9834.jpg";